<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" class="person-icon-dark">
    <g transform="translate(1 1)">
      <path class="a" d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" transform="translate(-4 -3)"/>
      <circle class="a" cx="4" cy="4" r="4" transform="translate(4)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "PersonIconDark"
}
</script>

<style scoped>.a {
  fill: none;
  stroke: #3e4041;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
